import { Fragment } from 'react';
import './App.css';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ResponsiveAppBar from './components/appbar_v2/ResponsiveAppBar';
import HomeScreen from './screens/home_screen';
import AboutUsScreen from './screens/about_us_screen';
import OurTeamScreen from './screens/our_team_screen';
import TermsofserviceScreen from './screens/Terms_of_service_screen';
import CareersScreen from './screens/careers_screen';
import ContactUsScreen from './screens/contact_us_screen';
import ApplicationScreen from './screens/application_screen';
import PrivacyPolicyScreen from './screens/privacy_policy_screen';
import { PathsUrls } from './utils/path_url'; 
import Footer from './components/footer/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import RubaaiHelmet from './components/common/Helmet';

function App() {
  return (
    <Router>
      <Fragment>
        <RubaaiHelmet />
        <ScrollToTop />
        <ResponsiveAppBar />
        <Box component="main" sx={{ overflowX: 'hidden', width: '100%' }}>
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path={PathsUrls.home_v2} element={<HomeScreen />} />
            <Route path={PathsUrls.about} element={<AboutUsScreen />} />
            <Route path={PathsUrls.ourTeam} element={<OurTeamScreen />} />
            <Route path={PathsUrls.careers} element={<CareersScreen />} />
            <Route path={PathsUrls.contactUs} element={<ContactUsScreen />} />
            <Route path={PathsUrls.application} element={<ApplicationScreen />} />
            <Route path={PathsUrls.privacyPolicy} element={<PrivacyPolicyScreen />} />
            <Route path={PathsUrls.termsofservice} element={<TermsofserviceScreen />} />
          </Routes>
        </Box>
        <Footer />
      </Fragment>
    </Router>
  );
}

export default App;
